@if (isAccountGroupPartnerType$ | async) {
  @if (assignedContact$ | async; as salesContact) {
    <div class="name-and-avatar">
      <div class="assignee">{{ 'INBOX.TOPBAR.ASSIGNEE' | translate }}:</div>
      @if (salesContact.image !== null) {
        <glxy-avatar
          [src]="salesContact.image"
          [name]="salesContact.name ?? undefined"
          [width]="16"
        ></glxy-avatar>
      }
      <div>{{ salesContact.name }}</div>
    </div>
  }
}
